import React, { useEffect } from 'react';
import Style from './Styles/OrderItemsElementStyle'
import Settings from '../../../Settings/Settings'
import InputLabel from '@mui/material/InputLabel';
import MenuItem from '@mui/material/MenuItem';
import FormControl from '@mui/material/FormControl';
import Button from '@mui/material/Button';
import IconButton from '@mui/material/IconButton';
import DeleteIcon from '@mui/icons-material/Delete';
import TableRow from '@mui/material/TableRow';
import TableCell from '@mui/material/TableCell';
import TextField from '@mui/material/TextField';

export default function OrdersItemsComponent(props) {
    const classes = Style();
    const [quantity, setQuantity] = React.useState(props.element.ordersItemsQuantity)
    const [confirmDelete, setConmfirmDelete] = React.useState(false)
    useEffect(() => {
        }, []);

    const componentConstants = {
        ...props.componentConstants
      }
    
      const componentMethods = {
          ...props.componentMethods
      }

    const handleChangeQuantity = (event) => {
        setQuantity(parseInt(event.target.value))
    }

      const putOrderItemAction = () => {
        let accountToken = ''
        if(componentMethods.getLocalStorage('user') && componentMethods.getLocalStorage('user').tokensHash) {
            accountToken = '?accountToken=' + componentMethods.getLocalStorage('user').tokensHash
        }
        componentMethods.ajax(Settings.API_URL + Settings.API_ENDPOINT_ORDER_ITEMS + props.element.ordersItemsID + accountToken,{
            ordersItemsQuantity: quantity
        },'PUT',null, (data) => {
            componentMethods.addError(componentConstants.language.LANG_ORDER_UPDATED)
        })
      }


      const deleteOrdersItemsAction = () => {
        let accountToken = ''
        if(componentMethods.getLocalStorage('user') && componentMethods.getLocalStorage('user').tokensHash) {
            accountToken = '?accountToken=' + componentMethods.getLocalStorage('user').tokensHash
        }
        componentMethods.ajax(Settings.API_URL + Settings.API_ENDPOINT_ORDER_ITEMS + props.element.ordersItemsID + accountToken,{},'DELETE',null, (data) => {
            componentMethods.addError(componentConstants.language.LANG_ORDER_UPDATED)
            componentMethods.getOrderItemsAction()
            setConmfirmDelete(false)
        })
      }
        return (<TableRow>
            <TableCell>
                {props.element.shopProductsArticleId} / {props.element.shopProductsID}
            </TableCell>
            <TableCell>
            <TextField
                fullWidth
                    label={componentConstants.language.LANG_INSERT_QUANTITY}
                    type="search"
                    variant="standard"
                    value={quantity}
                    onChange={handleChangeQuantity}
                />
            </TableCell> 
            <TableCell>
                {parseInt(props.element.ordersItemsQuantity) !== parseInt(quantity) ?
                      <Button style={classes.button} color="primary" onClick={putOrderItemAction} fullWidth component="div" variant="contained">
                        {componentConstants.language.LANG_UPDATE_ORDERS_ITEMS_QUANTITY}
                    </Button>
                    :
                    null
                  }
                  {
                    confirmDelete ?
                    <React.Fragment>
                        <Button style={classes.button} color="primary" onClick={deleteOrdersItemsAction} fullWidth component="div" variant="contained">
                            {componentConstants.language.LANG_CONFIRM_DELETE}
                        </Button>
                        <Button style={classes.button} color="secondary" onClick={(e) => {setConmfirmDelete(false)}} fullWidth component="div" variant="outlined">
                            {componentConstants.language.LANG_CANCEL}
                        </Button>                        
                    </React.Fragment>
                    :
                    <IconButton color="secondary" component="span" onClick={() => {setConmfirmDelete(true) }}>
                        <DeleteIcon />
                    </IconButton>  
                  }
                  
            </TableCell>            
            </TableRow>

    );
}